import Chart from "chart.js"

const datasetConfiguration = ({ data, title }) => ({
  label: title,
  backgroundColor: "#ffdb63",
  borderColor: "#FDC435",
  lineTension: "0",
  borderWidth: "4",
  pointRadius: "0",
  pointBackgroundColor: "#FDC435",
  pointBorderColor: "#fff",
  pointBorderWidth: "3",
  pointHoverRadius: "7",
  pointHoverBorderColor: "#fff",
  pointHoverBackgroundColor: "#333",
  borderJoinStyle: "round",
  data,
})

const yAxisFormatter = (currency) => {
  if (!currency) { return (value) => value }

  return (value) => `${Number(value).toFixed(0)} ${currency}`
}

const tooltipFormatter = (currency) => {
  if (!currency) {
    return (tooltipItem, data) => (
      `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel}`
    )
  }

  return (tooltipItem, data) => (
    `${data.datasets[tooltipItem.datasetIndex].label}: ${Number(tooltipItem.yLabel).toFixed(2)} ${currency}`
  )
}

const ticksConfiguration = ({ currency, kind }) => {
  const ticks = {
    display: true,
    maxTicksLimit: kind === "bar" ? 10 : 5,
    beginAtZero: true,
    min: 0,
  }

  if (kind === "line") { ticks.callback = yAxisFormatter(currency) }

  return ticks
}

const tooltipsConfiguration = ({ currency, kind }) => {
  const tooltips = {
    backgroundColor: "#fff",
    titleFontColor: "#333",
    bodyFontColor: "#333",
  }

  if (kind === "line") {
    tooltips.callbacks = {
      label: tooltipFormatter(currency),
    }
  }

  return tooltips
}

export const chartConfiguration = ({ currency, data, kind, labels, title }) => ({
  type: kind,
  data: {
    labels,
    datasets: [datasetConfiguration({ data, title })],
  },
  options: {
    layout: {
      padding: 10,
    },
    legend: { display: false },
    scales: {
      xAxes: [
        {
          gridLines: { display: false },
          ticks: { maxTicksLimit: 10 },
        },
      ],
      yAxes: [
        {
          display: true,
          gridLines: { display: false },
          ticks: ticksConfiguration({ currency, kind }),
        },
      ],
    },
    tooltips: tooltipsConfiguration({ currency, kind }),
  },
})

export const createChart = (element, options) => (
  new Chart(element, chartConfiguration(options))
)
